if (typeof console == "undefined") {
    window.console = {
        log: function () { }
    };
}

if (typeof angular != 'undefined') {

    angular.module('exceptionOverride', []).factory('$exceptionHandler', function () {
        return function (exception, cause) {

            exception.message += ' (caused by "' + cause + '")';
            
            _LTracker.push({
                "angularError": {
                    "message": exception.message,
                    "stack": exception.stack
                }
            });

            console.log('%c ' + exception + ' ' + exception.stack, 'background: #222; color: #f00000;');
        };
    });

    angular.module('vendd', ['ngSanitize', 'exceptionOverride']).config(function ($interpolateProvider) {
        $interpolateProvider.startSymbol('{[{').endSymbol('}]}');
    });
}

$(document).ready(function () {

    LhApp.Function.initVisitorState();

    ControlInitiator.initAll();

    Scripts.init();

    LhApp.init();

    if (typeof angular != 'undefined')
        angular.bootstrap(document, ['vendd']);
    
    $('*[ng-controller]').removeAttr('x-cloak').removeClass('x-cloak');

});

(function () {
    var url = location.href.replace(/#.*$/, '');
    var c = url + '#foo';
    var a = document.createElement('a');
    a.href = '#foo';
    if (a.href === c) return;

    if (typeof window.addEventListener === 'function') {
        window.addEventListener('click', addClickEvent, false);
    } else if (typeof window.attachEvent === 'function' || typeof window.attachEvent === 'object') {
        window.attachEvent('onclick', addClickEvent);
    }

    function addClickEvent(event) {

        var e = event || window.event;
        var t = e.target || e.srcElement;

        while (t) {
            if (t instanceof HTMLAnchorElement) {
                break;
            }
            t = t.parentNode;
        }
        if (e.type && e.type.toLowerCase() == 'click'
			&& t && t.tagName && t.tagName.toLowerCase() == 'a'
			&& t.getAttribute('href')
			&& t.getAttribute('href').trim().indexOf('#') == 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            window.location.hash = ((t.hash == '') ? '#' : t.hash);
        }
    }
})();